import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const problems = ['Apuntes dispersos sin ningún orden claro', 'Bibliografía que no podés resumir ni retener', 'Parciales que estudiás de cero cada vez', 'Corrientes que se mezclan y confunden', 'Prácticas sin saber cómo armar una entrevista', 'Empezás el semestre con fuerza y lo terminás perdido'];
export function Problem() {
  return <section className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8" data-id="element-196">
      <div className="max-w-2xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-198">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-white mb-4" data-id="element-199">
            ¿Cuántas veces más vas a estudiar sin sistema?
          </h2>
          <p className="text-center text-gray-300 mb-8 text-lg" data-id="element-200">
            Sin organización, siempre terminás igual.
          </p>

          <div className="bg-brand-dark rounded-2xl p-6 border border-white/5 mb-8" data-id="element-201">
            <ul className="space-y-4" data-id="element-202">
              {problems.map((problem, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3 text-gray-200" data-id="element-203">
                  <div className="mt-0.5 bg-red-500/20 p-1 rounded-full flex-shrink-0" data-id="element-204">
                    <X className="w-3 h-3 text-red-400" data-id="element-205" />
                  </div>
                  <span className="text-[15px]" data-id="element-206">{problem}</span>
                </motion.li>)}
            </ul>
          </div>

          <div className="bg-signature-gradient rounded-2xl p-6 text-center shadow-lg" data-id="element-207">
            <p className="text-white font-medium text-lg" data-id="element-208">
              No es falta de ganas. Es falta de un sistema.
              <br data-id="element-209" />
              <span className="font-bold mt-2 block" data-id="element-210">
                Con PsiRecursos Pro, el próximo semestre puede ser diferente. Ψ
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}